"use strict";

angular.module("customer")
.directive("depositItem", function() {
    return {
        restrict: "E",
        controllerAs: "depositItemCtrl",
        templateUrl: require("./deposit-item.directive.html"),
        scope: true,
        bindToController: {
            depositItem: "="
        },
        controller: function() {}
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/cart/deposit-item.directive.js
// module id = 937
// module chunks = 0